import { parseChildren, parseChildrenWithoutText } from './core.parse-children.js';
import { parseXML } from './util.parse-xml.js';

function xml2ast(input, parsers, mimeType = "text/xml", options) {
  try {
    if (!input) {
      return [];
    }
    const { parseText = true } = options ?? {};
    const parser = parseText ? parseChildren : parseChildrenWithoutText;
    return parser(parseXML(input, mimeType), parsers, 0, options);
  } catch (err) {
    console.error("xml2ast", err);
    return [];
  }
}

export { xml2ast };
//# sourceMappingURL=core.xml2ast.js.map
